import React, {useEffect, useRef, useState} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from "@material-ui/core/es/CircularProgress/CircularProgress";
import BusinessSettings from "../../../BusinessSettings/BusinessSettings";
import './SettingsDialog.scss'
import axios from "axios";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/CloseRounded";
import packageJson from '../../../../../package.json';
import SettingsConfig from "../../../BusinessSettings/SettingsConfig";
import SettingsIcon from "@material-ui/icons/SettingsRounded";

export default function SettingsDialog(props) {
    const settingsConfig = useRef(null);
    const dialogClickedTimes = useRef(0);
    const [allowAdvancedChange, setAllowAdvancedChange] = useState(false);
    const [businessSettings, setBusinessSettings] = useState();

    useEffect(() => {
        settingsConfig.current = new SettingsConfig(props.business || {}, {withIdInput: false});
    }, []);

    useEffect(() => {
        settingsConfig.current.setSettings(props.business || {});
        setBusinessSettings({...props.business});
    }, [props.business]);

    function onSettingsChange(settings) {
        settingsConfig.current.setSettings(settings);
        setBusinessSettings(settings);
    }

    function handleClose() {
        if (props.onCancel)
            props.onCancel();
    }

    async function handleSave() {
        const {data: placeIdLocation} = await axios.get('/api/v2a/placeIdGeocode', {
            params: {
                placeId: businessSettings.placeId,
                bid: businessSettings.id
            }
        });

        props.editBusiness({...businessSettings, location: placeIdLocation});

        if (props.onSave)
            props.onSave();
    }

    function handleDialogClick() {
        if (dialogClickedTimes.current < 0)
            dialogClickedTimes.current = 0;

        dialogClickedTimes.current++;

        if (dialogClickedTimes.current === 6) {
            setAllowAdvancedChange(!allowAdvancedChange);

            dialogClickedTimes.current = 0;
        } else {
            setTimeout((() => {
                dialogClickedTimes.current--;
            }), 5000);
        }
    }

    return (
        <div>
            <Dialog
                scroll={'paper'}
                className="settings-dialog"
                open={props.open}
                fullWidth={true}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title"
                             onClick={handleDialogClick}>
                    <div className="settings-dialog-title-content">
                        <SettingsIcon style={{"fontSize": "32px"}}/>
                        &nbsp;
                        הגדרות
                    </div>
                </DialogTitle>
                <DialogContent dividers={true}>
                    {
                        !props.fetched ?
                            <div className="loading-wrapper">
                                <CircularProgress/>
                            </div>
                            :
                            <div className="settings">
                                <BusinessSettings advancedSettings={allowAdvancedChange}
                                                  onChange={onSettingsChange}
                                                  settings={businessSettings}/>
                            </div>
                    }
                </DialogContent>
                <DialogActions className="dialog-actions">
                    <IconButton className="close-button"
                                onClick={handleClose}>
                        <CloseIcon fontSize="small"/>
                    </IconButton>
                    <Button disabled={settingsConfig.current && settingsConfig.current.anyErrors()}
                            variant="contained" color="primary" onClick={handleSave}>
                        שמור
                    </Button>
                </DialogActions>
                <div className="web-client-version-text">
                    v{packageJson.version}
                </div>
            </Dialog>
        </div>
    );
}